<template>
  <div class="modal_wrap on">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">신고하기</h1>
        </div>
        <div class="modal_con">
          <div class="form_wrap">
            <div class="check_table" data-columns="">
              <!--'2열: data-columns="2"', '3열: data-columns="3"'-->
              <label
                ><input
                  type="radio"
                  name="report"
                  v-model="reason"
                  value="1"
                /><span>불쾌감 및 분란 유발</span></label
              >
              <label
                ><input
                  type="radio"
                  name="report"
                  v-model="reason"
                  value="2"
                /><span>상업적 목적의 홍보 및 도배</span></label
              >
              <label
                ><input
                  type="radio"
                  name="report"
                  v-model="reason"
                  value="3"
                /><span>음란성 및 청소년에게 부적절한 내용</span></label
              >
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn bo grey" @click="$emit('close')">닫기</button>
            <button class="btn" @click="$emit('report', reason)">
              신고하기
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      reason: 1,
    };
  },
};
</script>
